import { useMessage } from "@messageformat/react";
import { Lang } from "./types";

export function useLang(): Lang {
  const lang = useMessage("lang", {}) as Lang;
  return lang;
}

export function prodEnv() {
  return (
    process.env.GATSBY_ACTIVE_ENV === undefined &&
    process.env.NODE_ENV === "production"
  );
}

export function devOrEmulatorEnv() {
  return !prodEnv();
}

export function isUserInUS(): boolean {
  if (typeof window === "undefined") return false;

  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone) return false;

    const usTimeZones = new Set([
      // -- US States (Canonical) --
      "America/Adak",
      "America/Anchorage",
      "America/Boise",
      "America/Chicago",
      "America/Denver",
      "America/Detroit",
      "America/Indiana/Indianapolis",
      "America/Indiana/Knox",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Tell_City",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Juneau",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Los_Angeles",
      "America/Menominee",
      "America/Metlakatla",
      "America/New_York",
      "America/Nome",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Phoenix",
      "America/Sitka",
      "America/Yakutat",
      "Pacific/Honolulu",

      // -- US Territories --
      "Pacific/Guam",
      "Pacific/Saipan",
      "Pacific/Pago_Pago",
      "America/Puerto_Rico",
      "America/St_Thomas",

      // -- Common Aliases / Backward Compatibility --
      "US/Alaska",
      "US/Aleutian",
      "US/Arizona",
      "US/Central",
      "US/East-Indiana",
      "US/Eastern",
      "US/Hawaii",
      "US/Indiana-Starke",
      "US/Michigan",
      "US/Mountain",
      "US/Pacific",
      "US/Samoa",
    ]);

    return usTimeZones.has(timeZone);
  } catch {
    return false;
  }
}
